module.exports = __webpack_public_path__ + "img/smartlocal4.f5e83b70.png";